import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { englishFontFallbackMap, arabicFontFallbackMap } from 'src/screens/WhiteLabels/Templates/shared/fonts';
import withStyles from '@mui/styles/withStyles';
const styles = theme => ({
    mainDiv:{
        width:'73%',
        boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2)',
        borderRadius:'8px',
        display:'flex',
        flexDirection:'column',
        justifyContent:'space-around',
        alignSelf:'center',
        border: '1px solid #e4e8ed',
        backgroundColor:'#fff',
        [theme.breakpoints.between('xs','md')]: {
            width:'100%'
		}
    },

    header:{
        fontFamily:"'Poppins', sans-serif",
        fontWeight:'bold',
    },

    topHead:{
        backgroundColor:'#0F467A',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        padding:'10px',
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
        "& span":{
            fontFamily:"'Poppins', sans-serif",
            fontWeight:'bold',
            color:'#fff'
        }
    },

    footer:{
        backgroundColor:'#F5F6F8',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        justifyContent:'center',
        padding:'10px',
        borderBottomLeftRadius: '8px',
        borderBottomRightRadius: '8px',
    },

    rowDiv:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'center',
    },

    inDiv:{
        display:'flex',
        flexDirection:'column',
        padding:'10px 10px',
    },

    rowSequence:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center'
    },

    detailSpan:{
        marginLeft:'15px',
        fontSize:'15px',
        fontFamily: "'Poppins', sans-serif",
    },

    marLeft:{
        marginLeft:'15px'
    },

    marRight:{
        marginRight:'15px'
    },

    dSpan:{
        color: '#0F467A',
        fontFamily: "'Poppins', sans-serif",
        letterSpacing: '0.025em',
        width:'250px',
        minWidth:'250px',
        maxWidth:'250px',
        fontSize:'15px',
        [theme.breakpoints.between('xs','md')]: {
            width:'165px',
            minWidth:'165px',
            maxWidth:'165px',
		}
    },

    footerSpan:{
        color: '#0F467A',
        fontFamily: "'Poppins', sans-serif",
        letterSpacing: '0.025em',
        fontSize:'17px'
    },

    font15:{
        fontSize:'15px'
    },

    bigFont:{
        fontSize:'20px',
        [theme.breakpoints.between('xs','md')]: {
            fontSize:'17px'
		}
    }
})

class TotalPaymentSection extends React.Component {
    render() {
        const { reservationLength, withoutDicount, beforeTaxTotalPay, taxTotalAmount, currency, discount, wallet,totalPay, isWallet, acutalTotalPay, noMargin, classes,t,i18n, totalDisplayPrice,displayCurrency,isConvertCurrency, company, companyFonts } = this.props;
        const isRTL = i18n.translator.language;
        const englishFont = englishFontFallbackMap[companyFonts?.englishFont] || "'Poppins', serif";
        const arabicFont = arabicFontFallbackMap[companyFonts?.arabicFont] || '"Cairo", sans-serif';
        const fontFamily = isRTL === 'ar' ? arabicFont : englishFont;
        const totalPrice = parseFloat(withoutDicount).toFixed(2);
        const isApplyTax = company?.applyTax && company?.applyTaxPercentage;
        return(
            <div className={classes.mainDiv} style={{marginTop:noMargin ? '0px' : '10px'}}>
                <div className={classes.topHead}>
                    <span className={classes.header} style={{fontFamily}}>{t('booking.payment-title')}</span>
                </div>
                <div className={classes.inDiv}>
                    <div className={classes.rowSequence}>
                        <span className= {classes.dSpan} style={{fontFamily}}>{t('booking.payment-title2')}</span>
                        <span className={classes.detailSpan} style={{fontFamily}}>{reservationLength}</span>
                    </div>
                    <div className={classes.rowSequence}>
                        <span className= {classes.dSpan} style={{fontFamily}}><b>{t('booking.payment-title3')}</b></span>
                        <span className={`${classes.detailSpan} ${classes.font15}`} style={{fontFamily}}><b>{totalPrice > 0 ? `${totalPrice} ${currency}` : '---'}</b></span>
                    </div>

                    {discount ?
                        <div className={classes.rowSequence}>
                            <span className= {classes.dSpan} style={{fontFamily}}>{t('booking.payment-title4')}</span>
                            <span className={classes.detailSpan} style={{fontFamily}}>{discount > 0 ? `-${discount} ${currency}` : '---'}</span>
                        </div>
                    :
                        undefined
                    }
                  
                    {isApplyTax ?
                        <>
                            {beforeTaxTotalPay ?
                                <div className={classes.rowSequence} style={{marginTop:'10px'}}>
                                    <span className= {classes.dSpan} style={{fontFamily}}><b>{t('booking.beforeTax')}</b></span>
                                    <span className={`${classes.detailSpan} ${classes.font15}`} style={{fontFamily}}><b>{beforeTaxTotalPay > 0 ? `${beforeTaxTotalPay} ${currency}` : '---'}</b></span>
                                </div>
                            : null}

                            {taxTotalAmount ?
                            <div className={classes.rowSequence}>
                                <span className= {classes.dSpan} style={{fontFamily}}>{t('booking.tax',{number:company?.applyTaxPercentage})}</span>
                                <span className={classes.detailSpan} style={{fontFamily}}>{`${taxTotalAmount} ${currency}` || '---'}</span>
                            </div>
                            : null}
                        </>    
                    :
                        null
                    }

                    {wallet && isWallet ?
                        <div className={classes.rowSequence} style={{marginTop:'10px'}}>
                            <span className= {classes.dSpan} style={{fontFamily}}>{t('booking.payment-title5')}</span>
                            <span className={classes.detailSpan} style={{fontFamily}}>{acutalTotalPay > 0 ? `-${wallet <= acutalTotalPay ? wallet : acutalTotalPay } ${currency}` : '---'}</span>
                        </div>
                    :
                        undefined
                    }
                </div>
                <div className={classes.footer}>
                    <div className={classes.rowDiv}>
                        <span className={classes.footerSpan} style={{fontFamily}}>{t('booking.payment-title6')}</span> 
                        <span className={`${classes.detailSpan} ${classes.bigFont} ${isRTL === 'ar' ? classes.marRight : classes.marLeft}`} style={{fontFamily}}><b>{isConvertCurrency && displayCurrency ? `${totalDisplayPrice < 0 ? 0 : parseFloat(totalDisplayPrice).toFixed(2)} ${displayCurrency}` : `${totalPay < 0 ? 0 : parseFloat(totalPay).toFixed(2)} ${currency}`}</b></span>
                    </div>
                    {isConvertCurrency && displayCurrency ?
                    <span className={`${classes.detailSpan}`} style={{fontFamily,margin:'0px'}}>{`Pay ${totalPay < 0 ? 0 : parseFloat(totalPay).toFixed(2)} ${currency}`}</span>
                    : null}
                </div>
            </div>
        )}
}


const mapStateToProps = state => {
    return {
        company: state.company,
        companyFonts: state.cpFonts,
    }
};

export default connect(mapStateToProps,null)(withStyles(styles)(withTranslation('common')(TotalPaymentSection)));